package de.oevbs.kunde.kundenportal2.model.services.contract

import de.oevbs.businesspartner.bpcrmservice2.contract.model.ContractDetails
import de.oevbs.businesspartner.bpcrmservice2.contract.model.ContractList
import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse
import kotlinx.serialization.Serializable

@Serializable
data class ContractNumberPayload(val contractNumber: String)

abstract class ContractClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd alle aktiven Verträge des eingeloggten Users/Partners aus dem CRM und gibt sie in einer [ContractList]
     * zurück.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun contracts(includeCancelled: Boolean): ClientResponse<ContractList> =
        get("/contracts/list?cancelled=$includeCancelled")

    /**
     * Gibt den Vertrag [contractNumber] des eingeloggten Users/Partners aus dem CRM als [ContractDetails] zurück.
     * zurück.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun contractDetail(contractNumber: String): ClientResponse<ContractDetails> =
        post("/contracts", ContractNumberPayload(contractNumber))
}